import { RECAPTCHA_DETAILS } from '../actionTypes';

export const fetchRecaptchaDetails = (action) => ({
  type: RECAPTCHA_DETAILS.FETCH,
  payload: action.payload,
});
